import React from 'react';
import Lottie from 'lottie-react';
import emptyAnimation from '../assets/empty.json';
import notFoundAnimation from '../assets/not_found.json';
import listAnimation from '../assets/list.json';
import emptyBoxAnimation from '../assets/empty_box.json';
import invoicesAnimation from '../assets/invoices.json';
import upDownAnimation from '../assets/up_down.json';
import categoryAnimation from '../assets/category.json';
import conveyerAnimation from '../assets/conveyer.json';
import peopleAnimation from '../assets/people.json';
import verificationAnimation from '../assets/verification.json';
import travelAnimation from '../assets/travel.json';
import payrollAnimation from '../assets/payroll.json';
import trackingAnimation from '../assets/tracking.json';
import posAnimation from '../assets/pos.json';

export default function EmptyState({
  title = "No items found in this section",
  message = "Try a different category or search term",
  animationData,
  preset = "empty",
  className = ""
}) {
  const selectedAnimation = animationData || (
    preset === 'not_found' ? notFoundAnimation :
    preset === 'list' ? listAnimation :
    preset === 'box' || preset === 'empty_box' ? emptyBoxAnimation :
    preset === 'invoices' || preset === 'invoice' ? invoicesAnimation :
    preset === 'up_down' || preset === 'arrows' ? upDownAnimation :
    preset === 'category' || preset === 'categories' ? categoryAnimation :
    preset === 'conveyer' || preset === 'suppliers' ? conveyerAnimation :
    preset === 'people' || preset === 'customers' ? peopleAnimation :
    preset === 'verification' || preset === 'verify' ? verificationAnimation :
    preset === 'travel' || preset === 'leave' ? travelAnimation :
    preset === 'payroll' || preset === 'wallet' || preset === 'money' ? payrollAnimation :
    preset === 'tracking' || preset === 'analytics' ? trackingAnimation :
    preset === 'pos' || preset === 'billing' ? posAnimation :
    emptyAnimation
  );

  return (
    <div className={`flex flex-col items-center justify-center py-12 px-4 text-center ${className}`}>
      <div className="w-44 h-44 sm:w-52 sm:h-52 mb-3 flex items-center justify-center">
        <Lottie
          animationData={selectedAnimation}
          loop={true}
          autoplay={true}
          style={{ width: '100%', height: '100%' }}
        />
      </div>
      <h3 className="text-xl font-bold text-gray-700 tracking-tight">{title}</h3>
      {message && (
        <p className="text-sm font-medium text-gray-400 mt-1 max-w-sm">{message}</p>
      )}
    </div>
  );
}
